export default "blog";